export default class CharLoadData {
    constructor(_store){
        this.store = _store;
        this.loader = $('.loading');
    }

    loadData(_char, _callback){
        this.loader.show();
        Promise.all([
            this.loadInfo(_char),
            this.loadEquipments(_char),
            this.loadAbilities(_char),
            this.loadPointsEffects()
        ])
        .then( (results) => {
            // console.log('----',  results);
            _callback( results );
            this.loader.hide();
        });
    }

    loadCompareData(_charA, _charB, _callback){
        this.loader.show();
        Promise.all([
            this.loadInfo(_charA),
            this.loadEquipments(_charA),
            this.loadAbilities(_charA),
            this.loadInfo(_charB),
            this.loadEquipments(_charB),
            this.loadAbilities(_charB)
        ])
        .then( (results) => {
            _callback( results );
            this.loader.hide();
        });
    }

    loadAllowed(_char){
        return axios( {
            method: 'GET',
            url: `${this.store.getState().config.apiDomain}/ingame/api/character/allowed.json`,
            params: {c:_char}
        }).catch( (error) => {
            return { success: false };
        });
    }

    loadInfo(_char){
        return axios( {
            method: 'GET',
            url: `${this.store.getState().config.apiDomain}/ingame/api/character/info.json`,
            params: {c:_char}
        }).catch( (error) => {
            return { success: false };
        });
    }

    loadEquipments(_char){
        return axios( {
            method: 'GET',
            url: `${this.store.getState().config.apiDomain}/ingame/api/character/equipments.json`,
            params: {c:_char}
        }).catch( (error) => {
            return { success: false };
        });
    }

    loadAbilities(_char){
        return axios( {
            method: 'GET',
            url: `${this.store.getState().config.apiDomain}/ingame/api/character/abilities.json`,
            params: {c:_char}
        }).catch( (error) => {
            return { success: false };
        });
    }

    loadPointsEffects(){
        return axios( {
            method: 'GET',
            url: `${this.store.getState().config.apiDomain}/ingame/api/character/abilities/pointseffects.json`
        }).catch( (error) => {
            return { success: false };
        });
    }

} // end of class